import { render } from "./footer_app.vue?vue&type=template&id=04d672be"
const script = {}

import "./footer_app.vue?vue&type=style&index=0&id=04d672be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__